export default __webpack_public_path__ + "static/media/100.97a2ab94.png";